var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Fehler beim Laden der Seite!")]),_c('h3',[_vm._v(" Es gab einen Serverfehler beim Laden der Seite. "),_c('br'),_vm._v("Wenn der Fehler besteht melden Sie sich beim Support: "),_c('a',{attrs:{"href":"mailto:support@govforms.ch"}},[_vm._v("support@govforms.ch")])])])
}]

export { render, staticRenderFns }